import React from 'react'
import PropTypes from 'prop-types'

class BorderBox extends React.Component {
  render() {
    return <div className="borderbox">{this.props.children}</div>
  }
}

BorderBox.propTypes = {
  children: PropTypes.node,
}

export default BorderBox
